<template>
  <router-view />
  <GlobalSnackbar />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import { useInitAppStore } from '@/stores/useInitAppStore';
import GlobalSnackbar from '@/components/ui/GlobalSnackbar.vue';

useInitAppStore();
// this should be enabled when we will start using Teams app
// if (isElectron()) useTeamsElectronBridge();
</script>
